var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.reconciliationObject != null
    ? _c(
        "div",
        [
          _c("b-container", { attrs: { fluid: "" } }, [
            _c(
              "div",
              { staticClass: "content-title" },
              [
                _c("b-row", [
                  _c("h1", [_vm._v("Reconcile VIBAN")]),
                  _vm._v(" "),
                  _c("div", [
                    _vm.balance < 0
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "background-color": "#f54a00",
                              color: "#fff",
                              "border-radius": "calc(.625rem - 2px)",
                              padding: "0.2rem 0.5rem",
                            },
                          },
                          [
                            _vm._v(
                              "Outstanding: -€" +
                                _vm._s(
                                  _vm.balance.toFixed(2).toString().slice(1)
                                )
                            ),
                          ]
                        )
                      : _vm.balance > 0
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "background-color": "#f54a00",
                              color: "#fff",
                              "border-radius": "calc(.625rem - 2px)",
                              padding: "0.2rem 0.5rem",
                            },
                          },
                          [
                            _vm._v(
                              "Outstanding: €" + _vm._s(_vm.balance.toFixed(2))
                            ),
                          ]
                        )
                      : _c(
                          "span",
                          {
                            staticStyle: {
                              "background-color": "#00a63e",
                              color: "#fff",
                              "border-radius": "calc(.625rem - 2px)",
                              padding: "0.2rem 0.5rem",
                            },
                          },
                          [_vm._v("Balanced")]
                        ),
                  ]),
                ]),
                _vm._v(" "),
                _c("b-row", [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#4a5565",
                        "font-size": "1.125rem",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#155dfc",
                            "font-size": "1.2rem",
                          },
                        },
                        [_vm._v(_vm._s(_vm.reconciliationObject.VIBAN))]
                      ),
                      _vm._v(
                        " • Client: " +
                          _vm._s(_vm.reconciliationObject.Reference1)
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "cards-container" },
            [
              _c("b-col", [
                _c("div", [
                  _c("div", [
                    _c("i", { staticClass: "fa-solid fa-dollar-sign" }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "Unmatched Payments (" +
                          _vm._s(_vm.unmatchedPayments.length) +
                          ")"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", { staticClass: "btn btn-selection" }, [
                      _vm._v(
                        "Selected: " + _vm._s(_vm.selectedPayments.length)
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("input", {
                  staticClass: "filter-item-content",
                  attrs: { type: "text", placeholder: "Search payments..." },
                  on: {
                    input: function (event) {
                      return (
                        (_vm.search.payment = _vm.sanitize(event.target.value)),
                        _vm.searchPayment()
                      )
                    },
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.searchPayment()
                    },
                  },
                }),
                _vm._v(" "),
                !_vm.paymentsLoading && _vm.search.paymentResults.length > 0
                  ? _c(
                      "div",
                      _vm._l(
                        _vm.search.paymentResults,
                        function (payment, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              class: [
                                "payment-container",
                                {
                                  active: _vm.selectedPayments.some(function (
                                    p
                                  ) {
                                    return (
                                      p.date == payment.date &&
                                      p.amount == payment.amount
                                    )
                                  }),
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.parentClicked("payment_" + index)
                                },
                              },
                            },
                            [
                              _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "custom-checkbox",
                                    on: {
                                      click: function ($event) {
                                        return _vm.parentClicked(
                                          "payment_" + index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("input", {
                                      ref: "payment_" + index,
                                      refInFor: true,
                                      attrs: { type: "checkbox" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                        },
                                        value: payment,
                                        change: function ($event) {
                                          return _vm.togglePaymentsSelected(
                                            $event,
                                            index,
                                            payment
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "checkmark" }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "€" +
                                      _vm._s(
                                        Number(payment.LeftAmount).toFixed(2)
                                      )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(payment.date))]),
                            ]
                          )
                        }
                      ),
                      0
                    )
                  : !_vm.paymentsLoading && _vm.unmatchedPayments.length > 0
                  ? _c(
                      "div",
                      _vm._l(_vm.unmatchedPayments, function (payment, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            class: [
                              "payment-container",
                              {
                                active: _vm.selectedPayments.some(function (p) {
                                  return (
                                    p.date == payment.date &&
                                    p.amount == payment.amount
                                  )
                                }),
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.parentClicked("payment_" + index)
                              },
                            },
                          },
                          [
                            _c("div", [
                              _c(
                                "label",
                                {
                                  staticClass: "custom-checkbox",
                                  on: {
                                    click: function ($event) {
                                      return _vm.parentClicked(
                                        "payment_" + index
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("input", {
                                    ref: "payment_" + index,
                                    refInFor: true,
                                    attrs: { type: "checkbox" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                      value: payment,
                                      change: function ($event) {
                                        return _vm.togglePaymentsSelected(
                                          $event,
                                          index,
                                          payment
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "checkmark" }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "€" +
                                    _vm._s(
                                      Number(payment.LeftAmount).toFixed(2)
                                    )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.formatDate(payment.CreationDate))
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    )
                  : _c("div", [
                      _vm.paymentsLoading
                        ? _c("span", [_vm._v("Loading...")])
                        : this.search.payment.length > 0
                        ? _c("span", [_vm._v("No payments match your search")])
                        : _c("span", [_vm._v("No unmatched payments")]),
                    ]),
              ]),
              _vm._v(" "),
              _c("b-col", [
                _c("div", [
                  _c("div", [
                    _c("i", { staticClass: "fa-regular fa-credit-card" }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "Other Events (" + _vm._s(_vm.otherEvents.length) + ")"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        gap: "0.5rem",
                        "align-items": "center",
                      },
                    },
                    [
                      _c("span", { staticClass: "btn btn-selection" }, [
                        _vm._v(
                          "Selected: " + _vm._s(_vm.selectedOtherEvents.length)
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-light",
                          on: {
                            click: function ($event) {
                              return _vm.openModal("create")
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fa-regular fa-plus" }),
                          _vm._v("Create"),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("input", {
                  staticClass: "filter-item-content",
                  attrs: { type: "text", placeholder: "Search events..." },
                  on: {
                    input: function (event) {
                      return (
                        (_vm.search.otherEvents = _vm.sanitize(
                          event.target.value
                        )),
                        _vm.searchOtherEvents()
                      )
                    },
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.searchOtherEvents()
                    },
                  },
                }),
                _vm._v(" "),
                !_vm.otherEventsLoading &&
                _vm.search.otherEventsResults.length > 0
                  ? _c(
                      "div",
                      _vm._l(
                        _vm.search.otherEventsResults,
                        function (otherEvent, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              class: [
                                "otherEvent-container",
                                {
                                  active: _vm.selectedOtherEvents.some(
                                    function (r) {
                                      return r.index == index
                                    }
                                  ),
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.parentClicked(
                                    "otherEvent_" + index
                                  )
                                },
                              },
                            },
                            [
                              _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "custom-checkbox",
                                    on: {
                                      click: function ($event) {
                                        return _vm.parentClicked(
                                          "otherEvent_" + index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("input", {
                                      ref: "otherEvent_" + index,
                                      refInFor: true,
                                      attrs: { type: "checkbox" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                        },
                                        value: otherEvent,
                                        change: function ($event) {
                                          return _vm.toggleOtherEventsSelected(
                                            $event,
                                            index,
                                            otherEvent
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "checkmark" }),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("div", [
                                  _c("span", [
                                    _vm._v(
                                      "€" +
                                        _vm._s(
                                          Number(otherEvent.Amount).toFixed(2)
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "baseline",
                                        gap: "1rem",
                                        "text-wrap": "nowrap",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { display: "grid" } },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "Created: " +
                                                _vm._s(
                                                  _vm.formatDate(
                                                    otherEvent.CreationDate
                                                  )
                                                )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "btn-selection btn" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              otherEvent.Type == 0
                                                ? "Refund"
                                                : "Credit Note"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      otherEvent.CustomerEmail
                                        ? otherEvent.CustomerEmail
                                        : ""
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        }
                      ),
                      0
                    )
                  : !_vm.otherEventsLoading && _vm.otherEvents.length > 0
                  ? _c(
                      "div",
                      _vm._l(_vm.otherEvents, function (otherEvent, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            class: [
                              "otherEvent-container",
                              {
                                active: _vm.selectedOtherEvents.some(function (
                                  r
                                ) {
                                  return r.index == index
                                }),
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.parentClicked("otherEvent_" + index)
                              },
                            },
                          },
                          [
                            _c("div", [
                              _c(
                                "label",
                                {
                                  staticClass: "custom-checkbox",
                                  on: {
                                    click: function ($event) {
                                      return _vm.parentClicked(
                                        "otherEvent_" + index
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("input", {
                                    ref: "otherEvent_" + index,
                                    refInFor: true,
                                    attrs: { type: "checkbox" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                      value: otherEvent,
                                      change: function ($event) {
                                        return _vm.toggleOtherEventsSelected(
                                          $event,
                                          index,
                                          otherEvent
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "checkmark" }),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "€" +
                                      _vm._s(
                                        Number(otherEvent.Amount).toFixed(2)
                                      )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "baseline",
                                      gap: "1rem",
                                      "text-wrap": "nowrap",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "grid" } },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "Created: " +
                                              _vm._s(
                                                _vm.formatDate(
                                                  otherEvent.CreationDate
                                                )
                                              )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "btn-selection btn" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            otherEvent.Type == 11
                                              ? "Refund"
                                              : "Credit Note"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    otherEvent.CustomerEmail
                                      ? otherEvent.CustomerEmail
                                      : ""
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    )
                  : _c("div", [
                      _vm.otherEventsLoading
                        ? _c("span", [_vm._v("Loading...")])
                        : _vm.search.otherEvents.length > 0
                        ? _c("span", [_vm._v("No events match your search")])
                        : _c("span", [_vm._v("No other events")]),
                    ]),
              ]),
              _vm._v(" "),
              _c("b-col", [
                _c("div", [
                  _c("div", [
                    _c("i", { staticClass: "fa-regular fa-file-lines" }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "Unmatched Orders (" +
                          _vm._s(_vm.unmatchedOrders.length) +
                          ")"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", { staticClass: "btn btn-selection" }, [
                      _vm._v("Selected: " + _vm._s(_vm.selectedOrders.length)),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("input", {
                  staticClass: "filter-item-content",
                  attrs: { type: "text", placeholder: "Search orders..." },
                  on: {
                    input: function (event) {
                      return (
                        (_vm.search.order = _vm.sanitize(event.target.value)),
                        _vm.searchOrder()
                      )
                    },
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.searchOrder()
                    },
                  },
                }),
                _vm._v(" "),
                !_vm.ordersLoading && _vm.search.orderResults.length > 0
                  ? _c(
                      "div",
                      _vm._l(_vm.search.orderResults, function (order, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            class: [
                              "order-container",
                              {
                                active: _vm.selectedOrders.some(function (o) {
                                  return o.index == index
                                }),
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.parentClicked("order_" + index)
                              },
                            },
                          },
                          [
                            _c("div", [
                              _c(
                                "label",
                                {
                                  staticClass: "custom-checkbox",
                                  on: {
                                    click: function ($event) {
                                      return _vm.parentClicked("order_" + index)
                                    },
                                  },
                                },
                                [
                                  _c("input", {
                                    ref: "order_" + index,
                                    refInFor: true,
                                    attrs: { type: "checkbox" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                      value: order,
                                      change: function ($event) {
                                        return _vm.toggleOrdersSelected(
                                          $event,
                                          index,
                                          order
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "checkmark" }),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "€" +
                                      _vm._s(Number(order.Amount).toFixed(2))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                      gap: "1rem",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "grid" } },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "Created: " +
                                              _vm._s(
                                                _vm.formatDate(
                                                  order.CreationDate
                                                )
                                              )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-size": "0.8rem",
                                              color: "#f54a00",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "Due: " +
                                                _vm._s(
                                                  _vm.formatDate(
                                                    order.CreationDate
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn-delete",
                                        on: {
                                          click: function ($event) {
                                            _vm.openModal("cancel"),
                                              (_vm.helper.InvoiceIdentifier =
                                                order.Invoices[0].InvoiceIdentifier)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-regular fa-circle-xmark",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(order.Invoices[0].InvoiceIdentifier)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    order.CustomerEmail
                                      ? order.CustomerEmail
                                      : ""
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    )
                  : !_vm.ordersLoading && _vm.unmatchedOrders.length > 0
                  ? _c(
                      "div",
                      _vm._l(_vm.unmatchedOrders, function (order, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            class: [
                              "order-container",
                              {
                                active: _vm.selectedOrders.some(function (o) {
                                  return o.index == index
                                }),
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.parentClicked("order_" + index)
                              },
                            },
                          },
                          [
                            _c("div", [
                              _c(
                                "label",
                                {
                                  staticClass: "custom-checkbox",
                                  on: {
                                    click: function ($event) {
                                      return _vm.parentClicked("order_" + index)
                                    },
                                  },
                                },
                                [
                                  _c("input", {
                                    ref: "order_" + index,
                                    refInFor: true,
                                    attrs: { type: "checkbox" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                      value: order,
                                      change: function ($event) {
                                        return _vm.toggleOrdersSelected(
                                          $event,
                                          index,
                                          order
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "checkmark" }),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "€" +
                                      _vm._s(Number(order.Amount).toFixed(2))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                      gap: "1rem",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "grid" } },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "Created: " +
                                              _vm._s(
                                                _vm.formatDate(
                                                  order.CreationDate
                                                )
                                              )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-size": "0.8rem",
                                              color: "#f54a00",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "Due: " +
                                                _vm._s(
                                                  _vm.formatDate(
                                                    order.CreationDate
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn-delete",
                                        on: {
                                          click: function ($event) {
                                            _vm.openModal("cancel"),
                                              (_vm.helper.Amount =
                                                order.Amount),
                                              (_vm.helper.InvoiceIdentifier =
                                                order.Invoices[0].InvoiceIdentifier)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-regular fa-circle-xmark",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(order.Invoices[0].InvoiceIdentifier)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    order.CustomerEmail
                                      ? order.CustomerEmail
                                      : ""
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    )
                  : _c("div", [
                      _vm.ordersLoading
                        ? _c("span", [_vm._v("Loading...")])
                        : _vm.search.order.length > 0
                        ? _c("span", [_vm._v("No orders match your search")])
                        : _c("span", [_vm._v("No unmatched orders")]),
                    ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isModalOpen
            ? _c("div", { staticClass: "modal-container" }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-content",
                    staticStyle: {
                      "max-height": "60rem",
                      "overflow-y": "scroll",
                    },
                  },
                  [
                    _c("div", [
                      _c("div", [
                        _c("i", {
                          class: [
                            "fa-regular",
                            {
                              "fa-file-xmark":
                                _vm.selectedModal == "create" &&
                                _vm.eventType == "Credit",
                              "fa-slab-press fa-credit-card":
                                _vm.selectedModal == "create" &&
                                _vm.eventType == "Refund",
                              "fa-circle-xmark": _vm.selectedModal == "cancel",
                            },
                          ],
                          style: {
                            color:
                              _vm.eventType == "Refund" ? "#f54a00" : "#9810fa",
                          },
                        }),
                        _vm._v(" "),
                        _c("h1", [
                          _vm._v(
                            _vm._s(
                              _vm.selectedModal == "cancel"
                                ? "Cancel Order"
                                : _vm.eventType == "Refund"
                                ? "Create Refund"
                                : "Create Credit Note"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fa-regular fa-xmark",
                        staticStyle: {
                          "font-weight": "bold",
                          cursor: "pointer",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.closeModal()
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _vm.selectedModal == "create" && _vm.eventType == "Refund"
                      ? _c("span", [
                          _vm._v(
                            "Create a refund for VIBAN " +
                              _vm._s(_vm.reconciliationObject.VIBAN) +
                              " that can be reconciled against orders"
                          ),
                        ])
                      : _vm.selectedModal == "create" &&
                        _vm.eventType == "Credit"
                      ? _c("span", [
                          _vm._v(
                            "Create a credit note for VIBAN " +
                              _vm._s(_vm.reconciliationObject.VIBAN) +
                              " that can be reconciled against orders"
                          ),
                        ])
                      : _c("span", [
                          _vm._v(
                            "Cancel order " +
                              _vm._s(_vm.helper.InvoiceIdentifier) +
                              " and create a cancellation entry for reconciliation"
                          ),
                        ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-container" }, [
                      _c("i", {
                        staticClass: "fa-regular fa-circle-exclamation",
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _c("span", [
                          _vm._v(
                            "How " +
                              _vm._s(
                                _vm.selectedModal == "cancel"
                                  ? "Order Cancellation"
                                  : _vm.eventType == "Refund"
                                  ? "Refunds"
                                  : "Credit Notes"
                              ) +
                              " Work:"
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.selectedModal == "create"
                          ? _c("ul", [
                              _c("li", [
                                _vm._v(
                                  _vm._s(
                                    _vm.eventType == "Refund"
                                      ? "Refunds are communicated by the merchant (already processed)"
                                      : "Credit notes can be partial or full order amount"
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  'Created entries appear in the "Other Events" column'
                                ),
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "Can be reconciled AGAINST orders to close them out"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "Optional: Link to a specific order for context"
                                ),
                              ]),
                            ])
                          : _c("ul", [
                              _c("li", [
                                _vm._v(
                                  'The order will be marked as "Cancelled"'
                                ),
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "A cancellation entry will be created in the transaction ledger"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "You can then reconcile the order WITH its cancellation entry"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "This closes out the order without requiring a payment"
                                ),
                              ]),
                            ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.selectedModal == "create"
                      ? _c("div", { staticStyle: { display: "grid" } }, [
                          _c(
                            "div",
                            { staticClass: "filter-item" },
                            [
                              _c("span", { staticClass: "filter-item-title" }, [
                                _vm._v("Event Type *"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "filter-item-content d-flex justify-content-between py-2 px-3",
                                  attrs: { id: "event-picker-link", href: "#" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "fixed-span-size",
                                      staticStyle: {
                                        display: "flex",
                                        gap: "0.5rem",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        class: [
                                          "fa-regular",
                                          {
                                            "fa-file-xmark":
                                              _vm.selectedModal == "create" &&
                                              _vm.eventType == "Credit",
                                            "fa-slab-press fa-credit-card":
                                              _vm.selectedModal == "create" &&
                                              _vm.eventType == "Refund",
                                          },
                                        ],
                                        style: {
                                          color:
                                            _vm.eventType == "Refund"
                                              ? "#f54a00"
                                              : "#9810fa",
                                        },
                                      }),
                                      _vm._v(
                                        _vm._s(
                                          _vm.eventType == "Refund"
                                            ? "Refund (Merchant Communicated)"
                                            : "Credit Note"
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa-light fa-chevron-down",
                                    attrs: { size: "17px", id: "page-chevron" },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target: "event-picker-link",
                                    triggers: "focus",
                                    placement: "bottom",
                                    "custom-class": "popover",
                                  },
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "span",
                                      {
                                        class: [
                                          "popover-option",
                                          {
                                            "popover-option-selected":
                                              _vm.eventType == "Refund",
                                          },
                                        ],
                                        staticStyle: {
                                          display: "flex",
                                          gap: "0.5rem",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.eventType = "Refund"
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-regular fa-slab-press fa-credit-card",
                                          staticStyle: { color: "#f54a00" },
                                        }),
                                        _vm._v(
                                          "Refund (Merchant Communicated)\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        class: [
                                          "popover-option",
                                          {
                                            "popover-option-selected":
                                              _vm.eventType == "Credit",
                                          },
                                        ],
                                        staticStyle: {
                                          display: "flex",
                                          gap: "0.5rem",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.eventType = "Credit"
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-regular fa-file-xmark",
                                          staticStyle: { color: "#9810fa" },
                                        }),
                                        _vm._v("Credit Note\n              "),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.eventType == "Refund"
                            ? _c(
                                "span",
                                { staticStyle: { color: "#4a5565" } },
                                [
                                  _vm._v(
                                    "Merchant has communicated that a refund was processed to the customer"
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.eventType == "Credit"
                            ? _c(
                                "span",
                                { staticStyle: { color: "#4a5565" } },
                                [
                                  _vm._v(
                                    "Record a credit note issued to the customer (can be partial or full amount)"
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "amount" } }, [
                            _vm._v("Amount (EUR) *"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "filter-item-content",
                            attrs: {
                              placeholder: "0.00",
                              type: "number",
                              id: "amount",
                            },
                            domProps: {
                              value:
                                _vm.helper.Amount != null
                                  ? _vm.helper.Amount
                                  : _vm.selectedOrder != null
                                  ? _vm.selectedOrder.Amount
                                  : 0.0,
                            },
                            on: {
                              input: function (event) {
                                return (_vm.helper.Amount = _vm.sanitize(
                                  event.target.value
                                ))
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.selectedOrder != null &&
                          _vm.helper.Amount != null &&
                          _vm.selectedOrder.Amount > _vm.helper.Amount
                            ? _c(
                                "small",
                                { staticStyle: { color: "#f54a00" } },
                                [
                                  _vm._v(
                                    "⚠️ Partial refund: €" +
                                      _vm._s(_vm.helper.Amount) +
                                      " of €" +
                                      _vm._s(
                                        Number(
                                          _vm.selectedOrder.Amount
                                        ).toFixed(2)
                                      )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedOrder != null &&
                          _vm.helper.Amount != null &&
                          _vm.selectedOrder.Amount == _vm.helper.Amount
                            ? _c(
                                "small",
                                { staticStyle: { color: "#00a63e" } },
                                [_vm._v("✓ Full refund amount")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectedOrder != null && _vm.helper.Amount == null
                            ? _c(
                                "small",
                                { staticStyle: { color: "#00a63e" } },
                                [_vm._v("✓ Full refund amount")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "reference" } }, [
                            _vm._v("Reference (Optional)"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "filter-item-content",
                            attrs: {
                              placeholder: "Leave empty to auto-generate",
                              type: "text",
                              id: "reference",
                            },
                            on: {
                              input: function (event) {
                                return (_vm.helper.InvoiceIdentifier =
                                  _vm.sanitize(event.target.value))
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("small", [
                            _vm._v(
                              "Will auto-generate if left empty (e.g., REF-1234567890)"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "description" } }, [
                            _vm._v("Description (Optional)"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "filter-item-content",
                            attrs: {
                              placeholder:
                                _vm.eventType == "Refund"
                                  ? "Merchant communicated that refund was processed..."
                                  : "Reason for credit note...",
                              type: "text",
                              id: "description",
                            },
                            on: {
                              input: function (event) {
                                return (_vm.helper.description = _vm.sanitize(
                                  event.target.value
                                ))
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("small", [
                            _vm._v(
                              "Will auto-generate based on event details if left empty"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Customer Email (Optional)"),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "filter-item-content",
                            attrs: {
                              placeholder: "customer@example.com",
                              type: "text",
                              id: "description",
                            },
                            on: {
                              input: function (event) {
                                return (_vm.helper.email = _vm.sanitize(
                                  event.target.value
                                ))
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "grid",
                                "row-gap": "0.5rem",
                              },
                            },
                            [
                              _c("span", { staticClass: "filter-item-title" }, [
                                _vm._v("Link to Order (Optional)"),
                              ]),
                              _vm._v(" "),
                              _c("small", [
                                _vm._v(
                                  "Link this " +
                                    _vm._s(
                                      _vm.eventType == "Refund"
                                        ? "refund"
                                        : "credit note"
                                    ) +
                                    " to a specific order for reference. This is optional - you can create standalone entries."
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                staticClass: "filter-item-content",
                                attrs: {
                                  type: "text",
                                  name: "searchOrder",
                                  id: "searchOrder",
                                  placeholder:
                                    "Search orders by reference, email, or status...",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "orders-container" },
                                [
                                  _c("div", [
                                    _c(
                                      "span",
                                      {
                                        class: {
                                          active: _vm.selectedOrder == null,
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.selectedOrder = null
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "No order selected (standalone entry)"
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.unmatchedOrders,
                                    function (order, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          class: {
                                            active: _vm.selectedOrder == order,
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.selectedOrder = order
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content":
                                                  "space-between",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    order.Invoices[0]
                                                      .InvoiceIdentifier
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("div", [
                                                _c("span"),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    "€" +
                                                      _vm._s(
                                                        Number(
                                                          order.Amount
                                                        ).toFixed(2)
                                                      )
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              "Date: " +
                                                _vm._s(
                                                  _vm.formatDate(
                                                    order.CreationDate
                                                  )
                                                ) +
                                                " - Outstanding: €" +
                                                _vm._s(
                                                  Number(order.Amount).toFixed(
                                                    2
                                                  )
                                                )
                                            ),
                                          ]),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.selectedOrder != null
                            ? _c(
                                "div",
                                {
                                  staticClass: "info-container",
                                  staticStyle: { display: "grid", gap: "0" },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "font-weight": "bold" } },
                                    [
                                      _vm._v(
                                        "Selected Order: " +
                                          _vm._s(
                                            _vm.selectedOrder.Invoices[0]
                                              .InvoiceIdentifier
                                          )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#4a5565" } },
                                    [
                                      _vm._v(
                                        "Amount: €" +
                                          _vm._s(
                                            Number(
                                              _vm.selectedOrder.Amount
                                            ).toFixed(2)
                                          )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#4a5565" } },
                                    [_vm._v("Status:")]
                                  ),
                                  _vm._v(" "),
                                  _vm.eventType == "Credit" &&
                                  Number(_vm.helper.Amount) <
                                    Number(_vm.selectedOrder.Amount)
                                    ? _c(
                                        "small",
                                        { staticStyle: { color: "#155dfc" } },
                                        [
                                          _vm._v(
                                            "💡 You can enter a partial amount for partial credit notes"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _c(
                          "div",
                          {
                            staticStyle: {
                              display: "grid",
                              margin: "1rem 0rem",
                            },
                          },
                          [
                            _c("label", { attrs: { for: "reference" } }, [
                              _vm._v("Cancellation Reason *"),
                            ]),
                            _vm._v(" "),
                            _c("textarea", {
                              staticClass: "filter-item-content",
                              staticStyle: {
                                "min-width": "100%",
                                "min-height": "5rem",
                              },
                              attrs: {
                                placeholder:
                                  "e.g., Customer cancelled order, Merchant cancelled due to stock unavailability...",
                                id: "reference",
                              },
                              on: {
                                input: function (event) {
                                  return (_vm.helper.description = _vm.sanitize(
                                    event.target.value
                                  ))
                                },
                              },
                            }),
                          ]
                        ),
                    _vm._v(" "),
                    _c("div", { staticClass: "summary-container" }, [
                      _c("span", [_vm._v("Summary")]),
                      _vm._v(" "),
                      _vm.selectedModal == "cancel"
                        ? _c("div", [
                            _c("span", [_vm._v("Order:")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.helper.InvoiceIdentifier)),
                            ]),
                          ])
                        : _c("div", [
                            _c("span", [_vm._v("Event Type:")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.eventType == "Refund"
                                    ? "Refund"
                                    : "Credit Note"
                                )
                              ),
                            ]),
                          ]),
                      _vm._v(" "),
                      _vm.selectedModal == "create"
                        ? _c("div", [
                            _c("span", [_vm._v("Amount:")]),
                            _vm._v(" "),
                            _c("span", { staticStyle: { color: "#f54a00" } }, [
                              _vm._v(
                                "€" +
                                  _vm._s(
                                    _vm.helper.Amount
                                      ? Number(_vm.helper.Amount).toFixed(2)
                                      : _vm.selectedOrder != null
                                      ? Number(
                                          _vm.selectedOrder.Amount
                                        ).toFixed(2)
                                      : "0.00"
                                  )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedModal == "create" && _vm.selectedOrder != null
                        ? _c("div", [
                            _c("span", [_vm._v("Linked Order:")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.selectedOrder.Invoices[0]
                                    .InvoiceIdentifier
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [
                        _c("span", [_vm._v("VIBAN:")]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticStyle: { "font-weight": "normal" } },
                          [_vm._v(_vm._s(_vm.reconciliationObject.VIBAN))]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("span", [_vm._v("Client:")]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticStyle: { "font-weight": "normal" } },
                          [_vm._v(_vm._s(_vm.reconciliationObject.Reference1))]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.selectedModal == "cancel"
                        ? _c("div", [
                            _c("span", [_vm._v("Action:")]),
                            _vm._v(" "),
                            _c("span", [_vm._v("Cancel Order")]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-content-buttons" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn-outline-light btn",
                          on: {
                            click: function ($event) {
                              return _vm.closeModal()
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _vm.selectedModal == "cancel"
                        ? _c(
                            "button",
                            {
                              staticClass: "btn-outline btn-red",
                              class: {
                                disabled:
                                  _vm.helper.description == null ||
                                  _vm.helper.description.length == 0,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.cancelOrder()
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-regular fa-circle-xmark",
                              }),
                              _vm._v("Cancel Order"),
                            ]
                          )
                        : _c(
                            "button",
                            {
                              staticClass: "btn-outline btn-blue",
                              on: {
                                click: function ($event) {
                                  _vm.eventType == "Refund"
                                    ? _vm.createRefund()
                                    : _vm.createCreditNote()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.eventType == "Refund"
                                    ? "Create Refund"
                                    : "Create Credit Note"
                                )
                              ),
                            ]
                          ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "balance-container" },
            [
              _c("h4", [_vm._v("Balance summary")]),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c("div", [
                      _c("span", [_vm._v("Payments Selected:")]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { color: "#00a63e" } }, [
                        _vm._v("€" + _vm._s(_vm.paymentsSum.toFixed(2))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [_vm._v("Refunds Selected:")]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { color: "#f54a00" } }, [
                        _vm._v(
                          "-€" + _vm._s(Number(_vm.refundsSum).toFixed(2))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.creditSum > 0
                      ? _c("div", [
                          _c("span", [_vm._v("+ Write-offs (Credits):")]),
                          _vm._v(" "),
                          _c("span", { staticStyle: { color: "#00a63e" } }, [
                            _vm._v("€" + _vm._s(_vm.creditSum.toFixed(2))),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("div", [
                      _c("h4", [_vm._v("Net Payments")]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { color: "#00a63e" } }, [
                        _vm._v(
                          "€" +
                            _vm._s(
                              (
                                _vm.paymentsSum -
                                _vm.refundsSum +
                                _vm.creditSum
                              ).toFixed(2)
                            )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _c("div", [
                      _c("span", [_vm._v("Orders Selected:")]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { color: "#155dfc" } }, [
                        _vm._v("€" + _vm._s(_vm.ordersSum.toFixed(2))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("div", [
                      _c("h4", [_vm._v("Net Orders:")]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { color: "#155dfc" } }, [
                        _vm._v("€" + _vm._s(_vm.ordersSum.toFixed(2))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("div", [
                      _c("h4", [_vm._v("Outstanding:")]),
                      _vm._v(" "),
                      _vm.balance === 0
                        ? _c("span", { staticStyle: { color: "#00a63e" } }, [
                            _vm._v("\n            €0.00\n          "),
                          ])
                        : _vm.balance < 0
                        ? _c("span", { staticStyle: { color: "#e7000b" } }, [
                            _vm._v(
                              "\n            €" +
                                _vm._s(_vm.balance.toFixed(2)) +
                                "\n          "
                            ),
                          ])
                        : _c("span", { staticStyle: { color: "#e7000b" } }, [
                            _vm._v(
                              "\n            €" +
                                _vm._s(Math.abs(_vm.balance.toFixed(2))) +
                                "\n          "
                            ),
                          ]),
                    ]),
                    _vm._v(" "),
                    _vm.balance == 0
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#00a63e",
                              display: "flex",
                              gap: "0.5rem",
                              "align-items": "center",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa-regular fa-circle-check",
                            }),
                            _vm._v("Balanced - Ready to reconcile"),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn-outline-light btn",
                  on: {
                    click: function ($event) {
                      return _vm.closeDetail()
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  class: [
                    "btn btn-validate",
                    { disabled: _vm.balance !== 0 || _vm.countSelected === 0 },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.rapprochement()
                    },
                  },
                },
                [_vm._v("Complete Reconciliation")]
              ),
            ]
          ),
          _vm._v(" "),
          _vm.isAlertOpen
            ? _c("alert-modal", [
                _c("span", [
                  _c("i", { staticClass: "fa-solid fa-circle-check" }),
                  _vm._v("Reconciliation sucessfully completed"),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.balance != 0
            ? _c("div", { staticClass: "alert" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", [
                  _vm.balance > 0
                    ? _c("span", [
                        _vm._v(
                          "Outstanding balance of €" +
                            _vm._s(Number(_vm.balance).toFixed(2)) +
                            ". Select additional payments/refunds or remove some orders to balance."
                        ),
                      ])
                    : _c("span", [
                        _vm._v(
                          "Outstanding balance of -€" +
                            _vm._s(
                              Number(_vm.balance).toFixed(0).toString().slice(1)
                            ) +
                            ". Remove some selections to balance."
                        ),
                      ]),
                ]),
              ])
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("i", { staticClass: "fa-regular fa-circle-exclamation" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }